/**
 * Feature flag for cross-reload resumable uploads.
 *
 * Flip to `true` once the backend ships `POST /videos/prepare-bunny-upload`
 * with optional `video_uuid` body field. That endpoint extension lets the FE
 * obtain a fresh TUS signature for an EXISTING `bunny_video_id`, which is the
 * load-bearing invariant: tus-js-client's persisted upload URL is bound to a
 * specific VideoId, so resume only works if the VideoId stays stable across
 * reloads.
 *
 * When `true`:
 * - Studio row's `InflightStaleSlot` shows a `[Re-upload video]` button.
 * - The resume click handler validates the picked file (name + size) and
 *   triggers the resume flow.
 *
 * When `false`:
 * - Stale rows show only `[Delete video]`.
 *
 * Validation rule for re-picked files: name + size match only. Per backend
 * guidance, `lastModified` can be bumped by Finder rename / image editors
 * without changing bytes; tus-js-client's own fingerprint already includes
 * lastModified internally, so a `findPreviousUploads` match implies the
 * file matches.
 */
export const RESUMABLE_UPLOADS_ENABLED = true;
